import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.css']
})
export class NumberInputComponent extends FormElementBase {
  constructor() {
    super();
  }
}
